export default () => ({
  campaignItems: [],
  loadingPage: false,
  permissions: null,
  meta: {
    currentPage: null,
    from: null,
    lastPage: null,
    perPage: null,
    to: null,
    total: null,
  },
  links: {
    first: null,
    last: null,
    next: null,
    prev: null,
  },
})
